import { render, staticRenderFns } from "./switchNode.vue?vue&type=template&id=a59c004e&scoped=true&"
import script from "./switchNode.vue?vue&type=script&lang=js&"
export * from "./switchNode.vue?vue&type=script&lang=js&"
import style0 from "./switchNode.vue?vue&type=style&index=0&id=a59c004e&prod&scoped=true&lang=css&"
import style1 from "./switchNode.vue?vue&type=style&index=1&id=a59c004e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59c004e",
  null
  
)

export default component.exports